// HomeGrade Pro's crest (transcript card), rendered inside HomeScholar for the
// companion cross-sell card. Mirrors the sibling app's Logo.jsx crest so the two
// shields read as one family. Light variant (used on paper surfaces).
type Props = { size?: number; title?: string; className?: string };

export function CompanionCrest({ size = 44, title = 'HomeGrade Pro', className }: Props) {
  const shieldFill = '#1d4434';
  const shieldStroke = '#a87f2f';
  const cardFill = '#f0ead6';
  const cardStroke = '#a87f2f';
  const foldFill = '#e0d7c2';
  const ink = '#1d4434';
  return (
    <svg
      width={size}
      height={Math.round((size * 108) / 96)}
      viewBox="0 0 96 108"
      role="img"
      aria-label={title}
      className={className}
    >
      <path d="M14 12 L82 12 L82 46 Q82 72 48 98 Q14 72 14 46 Z" fill={shieldFill} stroke={shieldStroke} strokeWidth={3} />
      <path d="M30 22 L60 22 L68 30 L68 66 L30 66 Z" fill={cardFill} stroke={cardStroke} strokeWidth={1} />
      <polygon points="60,22 68,30 60,30" fill={foldFill} />
      <line x1={37} y1={34} x2={61} y2={34} stroke={ink} strokeWidth={1.4} />
      <line x1={37} y1={41} x2={61} y2={41} stroke={ink} strokeWidth={1.4} />
      <line x1={37} y1={48} x2={59} y2={48} stroke={ink} strokeWidth={1.4} />
      <text x={49} y={62} textAnchor="middle" fontFamily="'Palatino Linotype','Book Antiqua',Palatino,Georgia,serif" fontSize={12} fill={ink}>A+</text>
    </svg>
  );
}
